// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_SalvaNovoCompromissoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos_servicos/salvaNovoCompromissoServico
 *
 * Creates a new compromisso_servico record, either from an existing orcamento_servico
 * or by creating both orcamento_servico and compromisso_servico.
 *
 * Data shape: boolean true on success
 *
 * @see Compromissos_servicos::salvaNovoCompromissoServico()
 * @see Atendente_interactor::IncluiServicoCompromissoParaServicoOrcamentoJaExistente()
 * @see Atendente_interactor::IncluiServicoCompromissoSemServicoOrcamento()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CompromissosServicos_SalvaNovoCompromissoServicoResponseDados = boolean;

export type CompromissosServicos_SalvaNovoCompromissoServicoResponse = ApiResponse<CompromissosServicos_SalvaNovoCompromissoServicoResponseDados>;

registerResponseContract('CompromissosServicos_SalvaNovoCompromissoServicoResponse', {})
